import React, { useState, useEffect } from "react";
import "./ProjectTable.css";
import { useDispatch, useSelector } from "react-redux";
import { setisProjectModal } from "../../store/slice/clientSlice.js";
import FreeSoloCreateOption from "../../Components/SearchDropdown/index.js";
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from '@mui/material/Pagination';
import axios from "axios";

import {
  setIsBugPage,
  setSelectedProject,
  setSelectedProjectBugs,
  setIsBugDashboard,
  setLoading
} from "../../store/slice/bugSlice.js";
import { setSelectedClientProjects, setLoading as setClientLoading } from "../../store/slice/clientSlice.js";
import {getProjectByClientId, getProjectsByClientIdPaginated, getAllProjectNames, getProjectById, updateProjectTaskStatus, getProjectNamesByClientId} from '../../services/homeService'
import { setIsProjectSetup } from "../../store/slice/setupSlice.js";

import EmptyState from "../../Components/EmptyState/EmptyState";
import DashboardIcon from "../../assets/icons/dashboardIcon.svg";
import BugIcon from "../../assets/icons/bugIcon.svg";
import SetupIcon from "../../assets/icons/setupIcon.svg";
import EditIcon from "../../assets/icons/edit.svg";
import ProjectBug from "../../Components/ProjectBug/ProjectBug.jsx";
import { getBugsByProjId } from "../../services/homeService";
import BugDashboard from "../BugDashboard/BugDashboard";
import ProjectSetup from "../ProjectSetup/ProjectSetup";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import deleteIcon from "../../assets/icons/deleteIcon_1.svg";
import { getCookie } from "../../services/utils";
import loginData from '../BugList/userLoginIds.json';


const ProjectTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientId } = useParams();
  const location = useLocation();
  
  // Pagination states
  const [page, setPage] = useState(0); // Page is 0-indexed for API
  const [pageSize, setPageSize] = useState(5); // Number of projects per page
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);
  
  // Search states
  const [allProjectNames, setAllProjectNames] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const projectHeaders = [
    { header: "S. No.", key: "index" },

    { header: "Project Name", key: "projectName" },

    { header: "Feature", key: "feature" },

    { header: "Bug Count", key: "bugcount" },
    
    { header: "Status", key: "status" },

    { header: "Action", key: "action" },
  ];
  
  // Status options for dropdown - only include valid options for projects
  const statusOptions = ["Start", "On Hold", "To Do"];
  const [value, setValue] = useState(null);
  let count = 0;

  const { selectedClientProjects, selectedClient, loading } = useSelector((state) => {
    // Log the projects as they come in from Redux
    if (state.clientDetails.selectedClientProjects && state.clientDetails.selectedClientProjects.length > 0) {
      // console.log("Projects from Redux:", state.clientDetails.selectedClientProjects);
      // Log the jiraStatus values for each project
      // console.log("Project jiraStatus values:", state.clientDetails.selectedClientProjects.map(p => ({
      //   name: p.name,
      //   jiraStatus: p.jiraStatus
      // })));
    }
    return state.clientDetails;
  });

  const { isBugPage, isBugDashboard } = useSelector((state) => {
    return state.bugDetails;
  });

  const { isProjectSetup } = useSelector((state) => {
    return state.setupDetails;
  });

  // Get the user's email from cookies and check if they are an approver
  const email = getCookie("email");
  const isApprovedUser = loginData.login.includes(email);
  console.log("isApprovedUser", isApprovedUser);
  
  // No need to fetch project statuses separately as they come with project data


  const handleAddProject = () => {
    dispatch(setisProjectModal(true));
  };
  const getBugsByProjIdApi = async (selectedProjectId) => {
    try {
      setLoading(true);
      const res = await getBugsByProjId(selectedProjectId);
      setLoading(false);
      if (res && res.length === 0) {
        setLoading(false);
      } else if (res) {
        dispatch(setSelectedProjectBugs(res));
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching clients:", error.message);
      setLoading(false);
    }
  };

  const handleBugBtn = (item) => {
    const state = {
      clientName: selectedClient?.label,
      projectName: item?.name,
      guid: item?.guid,
    };
    let selectedProjectId = item.id;
    dispatch(setSelectedProjectBugs([]));
    getBugsByProjIdApi(selectedProjectId);
    dispatch(setSelectedProject(item));
    dispatch(setIsBugPage(true));
    navigate(`./client/${selectedClient?.value}/project/${item?.id}`, {
      state,
    });
  };

  const handleDashboardBtn = (item) => {
    dispatch(setIsBugDashboard(true));
    dispatch(setSelectedProject(item));
    const state = {
      clientName: selectedClient.label,
      projectName: item?.name,
      guid: item?.guid,
    };
    navigate(`./client/${clientId}/project/${item?.id}/dashboard`, { state });
  };
  const options = allProjectNames?.map((project) => ({
    title: project.name,
    id: project.id
  }));

  const handleProjectSetupBtn = (item) => {
    dispatch(setIsProjectSetup(true));
    dispatch(setSelectedProject(item));
    
    // Store whether this is a new setup or modification
    const isModifying = item.featureCount > 0;
    const state = {
      clientName: selectedClient.label,
      projectName: item?.name,
      guid: item?.guid,
      isModifying: isModifying, // Add this flag to track whether we're modifying or setting up
    };
    navigate(`./client/${clientId}/project/${item?.id}/feature`, { state });
  };

  const handleSubtasksBtn = (item) => {
    const state = {
      clientName: selectedClient.label,
      projectName: item?.name,
      guid: item?.guid,
    };
    navigate(`./client/${clientId}/project/${item?.id}/subtasks`, { state });
  };

  const handleBackPageSetup = async () => {
    dispatch(setIsProjectSetup(false));
    dispatch(setSelectedProject({}));
    
    // Refresh project data to ensure we have the latest feature counts
    // This will update the UI to show the correct button states
    await handleRefreshProjects();
    
    const state = { clientName: selectedClient.label };
    navigate(`./client/${clientId}`, { state });
  };

  const handleStatusChange = async (project, newStatus) => {
    // Extra security check to prevent non-reviewer users from changing status
    if (!isApprovedUser) {
      console.warn("Unauthorized attempt to change project status by non-reviewer user");
      alert("You don't have permission to change project status. Please contact an administrator.");
      return;
    }
    
    try {
      console.log(`Before update - Project: ${project.name}, Current jiraStatus: "${project.jiraStatus}", New status: "${newStatus}"`);
      
      const resp = await updateProjectTaskStatus(project.name, newStatus);
      if(resp){
        console.log(`API response:`, resp);
        console.log(`Status updated for project ${project.name} to ${newStatus}`);
        
        // Update the jiraStatus of that particular project in Redux
        const updatedProjects = selectedClientProjects.map((proj) => {
          if (proj.id === project.id) {
            console.log(`Updating project in Redux - Before: "${proj.jiraStatus}", After: "${newStatus}"`);
            return { ...proj, jiraStatus: newStatus };
          }
          return proj;
        });
        
        // Dispatch updated projects to Redux store to persist the change
        dispatch(setSelectedClientProjects(updatedProjects));
        
        // Print the updated projects after update
        setTimeout(() => {
          const currentProjects = selectedClientProjects;
          const updatedProject = currentProjects.find(p => p.id === project.id);
          console.log(`After Redux update - Project jiraStatus: "${updatedProject?.jiraStatus}"`);
        }, 100);
      }
    } catch (error) {
      console.error("Error updating project status:", error);
      alert("Failed to update project status. Please try again later.");
    }
  };

  // Effect to check if we need to refresh projects (e.g., after coming from setup page)
  useEffect(() => {
    // Check if we've been redirected from ProjectSetup and need to refresh
    if (location.state && location.state.refreshNeeded) {
      console.log("Refresh needed from navigation state, refreshing projects");
      handleRefreshProjects();
    }
  }, [location.state]);

  // Effect to load projects when page, pageSize, or clientId changes
  useEffect(() => {
    handleRefreshProjects();
  }, [page, pageSize, clientId]);

  // Effect to load project names for search when clientId changes
  useEffect(() => {
    loadAllProjectNames();
  }, [clientId]);

  // Handle page change
  const handlePageChange = (event, newPage) => {
    setPage(newPage - 1); // Convert to 0-indexed for API
  };
  
  // Load all project names for search functionality
  const loadAllProjectNames = async () => {
    try {
      setSearchLoading(true);
      const names = await getProjectNamesByClientId(clientId);
      setAllProjectNames(names);
      setSearchLoading(false);
    } catch (error) {
      console.error("Error loading project names:", error);
      setSearchLoading(false);
    }
  };

  // Handle search selection - fetch project details by ID
  const handleSearchSelection = async (selectedProject) => {
    if (!selectedProject || !selectedProject.id) return;
    
    try {
      setSearchLoading(true);
      const projectDetails = await getProjectById(selectedProject.id);
      
      // Check if the selected project is already in the current page
      const existingProjectIndex = selectedClientProjects.findIndex(p => p.id === selectedProject.id);
      
      if (existingProjectIndex === -1) {
        // Project is not in current view, add it temporarily to show the search result
        const updatedProjects = [...selectedClientProjects, projectDetails];
        dispatch(setSelectedClientProjects(updatedProjects));
      }
      
      // Always set the selected project in search value to highlight it
      setValue({ title: projectDetails.name, id: projectDetails.id });
      
      setSearchLoading(false);
    } catch (error) {
      console.error("Error fetching project details:", error);
      setSearchLoading(false);
      alert("Error fetching project details. Please try again.");
    }
  };
  
  const handleDeleteBtn = async (item) => { 
  const projectId = item.id; // Get the project ID from the item
  const clientId = item.clientId;

  const confirmDelete = window.confirm("Are you sure you want to delete this project?");
  if (!confirmDelete) {
    return; 
  }

  try {
    const response = await axios.delete(`${process.env.REACT_APP_BUG_REPORTING_TOOL_URL}project/deleteProjectById/${projectId}`);

    if (response.status === 200) {
      alert(response.data); 
      // Update the Redux store directly by filtering out the deleted project
      const updatedProjects = selectedClientProjects.filter(proj => proj.id !== projectId);
      // Dispatch updated projects to Redux store to persist the change
      dispatch(setSelectedClientProjects(updatedProjects));
    } 
    else {
      throw new Error("Failed to delete the project");
    }
  } catch (error) {
    alert("Error: " + (error.response?.data || error.message)); // Show error message if the request fails
    console.error("Error:", error);
  }
};

// Function to refresh project data from API
const handleRefreshProjects = async () => {
  try {
    dispatch(setClientLoading(true));
    
    // Use paginated API instead of getting all projects
    const response = await getProjectsByClientIdPaginated(clientId, page, pageSize);
    
    // Check if the response has the expected pagination structure
    let freshProjects = [];
    if (response.content) {
      // Response is from the pagination endpoint with Jira status
      freshProjects = response.content;
      setTotalPages(response.totalPages);
      setTotalElements(response.totalElements);
    } else if (Array.isArray(response)) {
      // Handle case where the response is directly an array (not paginated)
      freshProjects = response;
      setTotalPages(Math.ceil(response.length / pageSize));
      setTotalElements(response.length);
    } else if (response.content === undefined && response.totalPages) {
      // Response is from pagination endpoint but no content field
      freshProjects = response.content || [];
      setTotalPages(response.totalPages);
      setTotalElements(response.totalElements);
    } else {
      // Fallback for any other response structure
      freshProjects = [];
      setTotalPages(1);
      setTotalElements(0);
    }
    
    console.log("Fresh projects from API:", freshProjects);
    
    // Log jiraStatus values for debugging
    if (freshProjects && freshProjects.length > 0) {
      console.log("Fresh projects jiraStatus values:", freshProjects.map(p => ({
        name: p.name,
        jiraStatus: p.jiraStatus,
        featureCount: p.featureCount
      })));
      
      // Log info about which buttons should be enabled/disabled
      freshProjects.forEach(project => {
        console.log(`Project ${project.name}: featureCount=${project.featureCount}, bugCount=${project.bugCount}`);
        console.log(`- Setup/Modify button text: ${project.featureCount === 0 ? 'Setup' : 'Modify'}`);
        console.log(`- Bugs button enabled: ${project.featureCount > 0}`);
        console.log(`- Dashboard button enabled: ${project.featureCount > 0 && project.bugCount > 0}`);
      });
    }
    
    // Update Redux store with fresh data
    dispatch(setSelectedClientProjects(freshProjects));
    
    // If there's a selected project from search, make sure it's still in the list
    if (value && value.id) {
      const selectedProjectExists = freshProjects.some(p => p.id === value.id);
      if (!selectedProjectExists) {
        // Try to fetch and add the selected project back
        try {
          const selectedProjectDetails = await getProjectById(value.id);
          const updatedProjects = [...freshProjects, selectedProjectDetails];
          dispatch(setSelectedClientProjects(updatedProjects));
        } catch (error) {
          console.error("Error refetching selected project:", error);
        }
      }
    }
    
    dispatch(setClientLoading(false));
    console.log("Projects refreshed from API");
  } catch (error) {
    console.error("Error refreshing projects:", error);
    dispatch(setClientLoading(false));
  }
};


  return isProjectSetup ? (
    <ProjectSetup handleBack={handleBackPageSetup} />
  ) : (
    <>
      {!isBugPage ? (
        loading ? (
          // Show loading spinner in the middle of the screen when loading
          <div className="loader">
            <CircularProgress />
          </div>
        ) : !selectedClientProjects.length ? (
          <EmptyState
            text={`You don't have any project added for this client.`}
            btnText={`Add Project`}
            handleBtn={handleAddProject}
          />

          
          
        ) : !isBugDashboard ? (
          <>
            <div
              className="projectTable"
            >
              <h2 className="tabletitle">Projects List</h2>
              <div style={{ position: "relative", width: "80%" }}>
                {/* Center search bar (original position) */}
                <div style={{ width: "60%", padding: "10px 20px", margin: "0 auto" }}>
                  <FreeSoloCreateOption
                    value={value}
                    setValue={setValue}
                    options={{ options }}
                    onSelection={handleSearchSelection}
                    loading={searchLoading}
                  />
                
                 
                </div>
                {/* Controls container - right side */}
                <div style={{ position: "absolute", top: "50%", right: "20px", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: "15px" }}>
                  {/* Page size selector */}
                  <div className="page-size-selector">
                    <span>Show:</span>
                    <select 
                      value={pageSize} 
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                        setPage(0); // Reset to first page when changing page size
                      }}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  
                  {/* Refresh button */}
                  <button 
                    onClick={handleRefreshProjects} 
                    className={`refresh-button ${loading ? 'refreshing' : ''}`}
                    title="Refresh projects from API"
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>
            <div className="project-table">
            <table>
              <thead>
                <tr>
                  {projectHeaders.map((header, index) => {
                    return (
                      <th
                        key={index}
                        style={{
                          textAlign:
                            header.header === "Project Name" ? "left" : "",
                        }}
                      >
                        {header.header}
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                {selectedClientProjects.map((item, index) => {
                  // Check if this project matches the search criteria
                  const matchesSearch = !value || !value.title || 
                    item?.name?.toLowerCase().includes(value?.title?.toLowerCase()) ||
                    (value.id && item.id === value.id); // Always show selected project
                  
                  return (
                    <tr
                      key={index}
                      className={`${index % 2 === 0 ? "evenRow" : "oddRow"} ${value && value.id === item.id ? "selected-project" : ""}`}
                      style={{
                        display: matchesSearch ? "table-row" : "none"
                      }}
                    >
                      <td>{(page * pageSize) + index + 1}</td>

                      <td style={{ textAlign: "left" }}>{item?.name}</td>

                      <td>{item?.featureCount}</td>

                      <td>{item?.bugCount}</td>
                      
                      <td className="status-cell">
                        <div className="status-container-project">
                          {item.jiraStatus === "No Status" ? (
                            <div></div>
                          ) : (
                            <div className={`status-readonly status-${item.jiraStatus?.replace(/\s+/g, '-').toLowerCase() || 'start'}`}>
                              <span className="status-indicator"></span>
                              <span className="status-text">{item.jiraStatus || 'Start'}</span>
                            </div>
                          )}
                        </div>
                      </td>

                      <td>
                      <div style={{display: 'flex', justifyContent: 'center', alignItem: 'center' }}>
                        {isApprovedUser && (
                          <button
                            className={
                              item.featureCount === 0 || item.bugCount === 0
                                ? "disable buttonClass"
                                : "buttonClass"
                            }
                            onClick={() => handleDashboardBtn(item)}
                            title={item.featureCount === 0 ? "Set up project features first" : 
                                   item.bugCount === 0 ? "No bugs available yet" : "View project dashboard"}
                          >
                            <img
                              src={DashboardIcon}
                              alt="dashboardIcon"
                              draggable={false}
                            />{" "}
                            Dashboard
                          </button>
                        )}

                        {isApprovedUser && (
                          <button
                            className={
                              item.featureCount === 0
                                ? "disable buttonClass"
                                : "buttonClass"
                            }
                            onClick={() => handleBugBtn(item)}
                            title={item.featureCount === 0 ? "Set up project features first" : "View bugs"}
                          >
                            <img
                              src={BugIcon}
                              alt="bugIcon"
                              draggable={false}
                            />{" "}
                            Bugs
                          </button>
                        )}

                        <button
                          className="buttonClass"
                          onClick={() => handleProjectSetupBtn(item)}
                        >
                          <img
                            src={SetupIcon}
                            // style={{ marginTop: "3px" }}
                            alt="setupIcon"
                            draggable={false}
                          />{" "}
                          {item.featureCount === 0 ? "Setup" : "Modify"}
                        </button>

                        <button
                          className="buttonClass"
                          onClick={() => handleSubtasksBtn(item)}
                          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                        >
                          <img
                            src={EditIcon}
                            alt="subtasksIcon"
                            draggable={false}
                            style={{ filter: 'invert(1)' }} // makes icon white
                          />
                          Subtasks
                          </button>

                        <button
                          // className="buttonClass"
                          disabled={!isApprovedUser} // Disable if the user is not an approver
                          onClick={() => handleDeleteBtn(item)}
                          className={`flex items-center justify-center`}
                          style={{
                            background: "transparent",
                            border: "none",
                            pointerEvents: !isApprovedUser ? "none" : "auto", // Ensure no interaction when disabled
                            opacity: !isApprovedUser ? 0.6 : 1,
                          }}
                      >
                        <img
                          src={deleteIcon}
                          alt="delete"
                          style={{
                            marginBottom: -2,
                            cursor: 'pointer'
                          }}
                        />
                      </button>
                      </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>
            {(() => {
              // Count visible projects that match the search or are selected
              const visibleMatchingProjects = selectedClientProjects.filter(item => 
                !value || !value.title || 
                item?.name?.toLowerCase().includes(value?.title?.toLowerCase()) ||
                (value.id && item.id === value.id)
              );
              
              return visibleMatchingProjects.length === 0 && value?.title ? (
                <div className="not-found">
                  No Projects Found matching your search.
                </div>
              ) : null;
            })()}
            
            {/* Pagination controls */}
            <div className="pagination-container">
              <Pagination 
                count={totalPages}
                page={page + 1} // Convert from 0-indexed to 1-indexed for UI
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
                size="large"
              />
              <div className="pagination-info">
                {value?.id || (value?.title && count === 1) ? (
                  // When showing search results
                  `Showing ${count} search ${count === 1 ? 'result' : 'results'} out of ${totalElements} total projects`
                ) : (
                  // Normal pagination display
                  `Showing ${selectedClientProjects.length > 0 ? ((page * pageSize) + 1) : 0} - ${Math.min((page + 1) * pageSize, totalElements)} of ${totalElements} projects`
                )}
              </div>
            </div>
            
          </>
        ) : (
          <BugDashboard />
        )
      ) : (
        <ProjectBug />
      )}
    </>
  );
};

export default ProjectTable;
